module.exports = __webpack_public_path__ + "static/media/SPB389.ccc07047.png";